import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { Link } from 'react-router';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/clubActions';
import ClubList from '../../components/club/ClubList';
import PermissionWrapper from '../../components/common/PermissionWrapper';
import Fuse from 'fuse.js';
import FontAwesome from 'react-fontawesome';

class ClubsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.deleteClub = this.deleteClub.bind(this);
    this.filterClubs = this.filterClubs.bind(this);
    this.state = {
      clubFilter: ""
    };
  }

  componentWillMount() {
    this.props.actions.loadClubs();
  }

  deleteClub(id) {
    this.props.actions.deleteClub(id);
  }

  filterClubs(e) {
    let clubFilter = e.target.value;
    this.setState({
      clubFilter: clubFilter
    });
  }

  render() {
    let filteredClubList = this.props.clubList;
    if(this.state.clubFilter) {
      let searchClubs = new Fuse(this.props.clubList,{
        keys: ["name",]
        });
      filteredClubList = searchClubs.search(this.state.clubFilter);
    }
    return (
      <div className="clubs-page-container container form-inline">
        <div className="page-header clearfix">
          <h1 className="">
            Klubber
          </h1>
          <div className="pull-right">
            <div className="input-group hidden-xs">
              <span className="input-group-addon" id="basic-addon3">
                <FontAwesome
                  name="search" />
              </span>
              <input
                type="text"
                className="form-control"
                onChange={this.filterClubs}
                value={this.state.clubFilter}
                />
            </div>
            {' '}
            <PermissionWrapper allowed={['super_admin', 'club_admin']}>
              <Link to={"/klubb/ny"} className="btn btn-primary">
                Ny klubb
              </Link>
            </PermissionWrapper>
          </div>
        </div>
        <div className="hidden-sm hidden-md hidden-lg hidden-xl">
          <div className="input-group">
            <span className="input-group-addon">
              <FontAwesome
                name="search" />
            </span>
            <input
              type="text"
              className="form-control"
              onChange={this.filterClubs}
              value={this.state.clubFilter}
              />
          </div>
          <hr/>
        </div>
        <ClubList
          clubList={filteredClubList}
          loading={this.props.loadingClubs} />
      </div>
    );
  }
}

ClubsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  clubList: PropTypes.array,
  loadingClubs: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    clubList: state.clubs.clubList,
    loadingClubs: state.clubs.loadingClubs,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClubsPage);



/** WEBPACK FOOTER **
 ** ./src/containers/clubs/ClubsPage.js
 **/